module.exports = __webpack_public_path__ + "img/alert-bell.321c4bf7.svg";